import { vn_app_zone_notification } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';
import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {channelsEdit_template} from '../components/templates/channelsEdit_template';
import {header} from './header';

declare var ko: any;
declare var page: any;

export class channels_edit extends vnModule_knockoutJS{

    protected channelEdit: channelsEdit_template
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return 'channels_edit';
    }

    buildContent(): Array<Element>{

        this.channelEdit = new channelsEdit_template('channels_edit', this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Channel Edit');

        return [this.channelEdit.build()];
    }

    public fillPage(): void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.channelEdit.setBrand(idBrand);
        }

        const idChannel = this.getVnAppZone().getApp().params.idChannel;
        this.getChannel(idChannel);

        this.channelEdit.setSocialMediaFilterItems();
        this.channelEdit.setSocialMediaLinks({}, true);
    }

    protected getChannel(idChannel){

        if(idChannel) {
            this.channelEdit.activateLoading();
            const idBrand = this.getVnAppZone().getApp().params.idBrand;
            const usrReq_url: string = `/api/brand/${idBrand}/channels/get/${idChannel}`;

            let usrReq_params: Array<Array<string>> = [];
            let vm = this.channelEdit.getViewModelForRequest();
            vm['lockItem'] = true;
            usrReq_params.push(['data', ko.toJSON(vm)] );

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetChannelRequestReturn;
            this.XHRHdl.execute();
        }
    }

    protected onGetChannelRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let channel = JSON.parse(req.request.response);
                channel.articles.forEach((article) => {
                    if(article.dateMostRecentPublishedStatus && article.dateMostRecentPublishedStatus.date) {
                        article.dateMostRecentPublishedStatus = article.dateMostRecentPublishedStatus.date;
                    }
                });

                obj.channelEdit.setChannel(channel);
            });

            obj.channelEdit.deactivateLoading();
        }
    }

    protected close(id){
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        this.releaseLock(idBrand, id, `/brand/${idBrand}/categorization/channels/view/${id}`);
    }

    protected cancel(id) {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        this.releaseLock(idBrand, id, `/brand/${idBrand}/categorization/channels/`);
    }


    protected releaseLock(idBrand, idChannel, redirectUrl) {
        if(idChannel) {
            this.cancelRequest("releaseLock");
            let subViewModel = {};
            let usrReq_url: string = `/api/brand/${idBrand}/channels/release/${idChannel}/`;
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

            if(redirectUrl) {
                this.XHRHdl.onReadyStateFunction = function() {
                    if(redirectUrl) {
                        page.redirect(redirectUrl);
                    }
                };
            }

            this.XHRHdl.execute();
        } else {
            if(redirectUrl) {
                page.redirect(redirectUrl);
            }
        }
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls !== undefined && this.XHRHdls[requestName] !== undefined) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    protected getUsersSuggestion(keyword, idElement) {
        this.cancelRequest("getUsersSuggestion");

        let subViewModel = { list: { keyword: keyword }, idElement: idElement };

        let usrReq_url: string = `/api/brand/${this.getVnAppZone().app.params.idBrand}/search/user/`;

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls["getUsersSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getUsersSuggestion"].onReadyStateFunction = this.onGetUsersSuggestions;
        this.XHRHdls["getUsersSuggestion"].execute();
    }

    protected onGetUsersSuggestions(req, obj) {
        return function () {

            obj.manageResponse(req, obj, function () {
                if(req.request.response){
                    let responseParsed = JSON.parse(req.request.response);

                    if (responseParsed.data.users) {
                        if (responseParsed.data.idElement == "creatorFilter") {
                            obj.channelEdit.setCreators(responseParsed.data.users);
                        }
                    }
                }
            });
        };
    }

    protected filterSimpleOnChange(idElement) {
        switch(idElement) {
            case "articleFilter":
                this.channelEdit.addArticle(this.channelEdit.articleFilter.getArticleObj());
                this.channelEdit.articleFilter.clearInput();
                break;
        }
    }

    protected save() {
        this.channelEdit.activateLoading();

        const idBrand = this.getVnAppZone().getApp().params.idBrand;

        this.cancelRequest("save");
        let modelForeRequest = this.channelEdit.getViewModelForRequest();
        const url = `/api/brand/${idBrand}/channels/save/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(modelForeRequest)]);

        this.XHRHdls["save"] = new XMLHttpRequestHandler(url, usrReq_params, this);
        this.XHRHdls["save"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["save"].onReadyStateFunction = this.onSaveChannelRequestReturn;
        this.XHRHdls["save"].execute();
    }

    protected onSaveChannelRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const idBrand = obj.getVnAppZone().getApp().params.idBrand;
                page.redirect(`/brand/${idBrand}/categorization/channels/`);

                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Channel saved successfully!",
                );
            });

            if(!(req.request.readyState == 4 && req.request.status == 200)) {
                obj.channelEdit.deactivateLoading();
            }
        };
    }

    protected filterMultipleSelectorOnChange(idElement, ){
        if(idElement == "socialMediaFilter") {
            this.channelEdit.updateSocialMediaSelection();
        }
    }

    protected getArticlesSuggestion(keyword, idElement) {
        this.cancelRequest("getArticlesSuggestion");

        let subViewModel = { list: { keyword: keyword }, idElement: idElement, templateName: "Video" };

        let usrReq_url: string = `/api/brand/${this.getVnAppZone().app.params.idBrand}/search/article/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls["getArticlesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getArticlesSuggestion"].onReadyStateFunction = this.onGetArticlesSuggestions;
        this.XHRHdls["getArticlesSuggestion"].execute();
    }

    protected onGetArticlesSuggestions(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                if(req.request.response){
                    let responseParsed = JSON.parse(req.request.response);
                    if (responseParsed.data.articles) {
                        if (responseParsed.data.idElement == "articleFilter") {
                            obj.channelEdit.articleFilter.setOptions(responseParsed.data.articles);
                        }
                    }
                }
            });
        };
    }

    protected showArticle(article) {
        if(article && article.id){
            const idBrand = this.getVnAppZone().getApp().params.idBrand;
            window.open(`/brand/${idBrand}/articles/view/${article.id}`, '_blank');
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/channels_edit.ts